export default __webpack_public_path__ + "static/media/NicolasRegnier.e62685db.webp";